import type { ReferringPhysician } from '../model/physician.types';

/**
 * Reshapes a flat referring physician form record into the nested payload the API expects, grouping address, city, state, country, zip, phone1, nightPhone and fax under a contact object. Leaves email and npi undefined when they are empty strings.
 *
 * @param referringPhysicianInfo - Flat referring physician record captured by the form.
 * @returns The API-shaped physician object with a nested contact block.
 */
const referringPhysicianInfoFormatter = (referringPhysicianInfo: ReferringPhysician) => ({
  firstName: referringPhysicianInfo.firstName,
  lastName: referringPhysicianInfo.lastName,
  title: referringPhysicianInfo.title,
  contact: {
    address: referringPhysicianInfo.address,
    city: referringPhysicianInfo.city,
    state: referringPhysicianInfo.state,
    country: referringPhysicianInfo.country,
    zip: referringPhysicianInfo.zip,
    phone1: referringPhysicianInfo.phone1,
    nightPhone: referringPhysicianInfo.nightPhone,
    fax: referringPhysicianInfo.fax,
  },
  email: referringPhysicianInfo.email || undefined,
  npi: referringPhysicianInfo.npi || undefined,
});

export { referringPhysicianInfoFormatter };
